import { AgreementModel } from './agreement.model';
import { VehicleRegistrationData } from './registration-offer-data/vehicle-registration-data.model';
import { InsurerRegistrationData } from './registration-offer-data/insurer-registration-data.model';
import { OwnerRegistrationData } from './registration-offer-data/owner-registration-data.model';
import { CessionData } from './cession-data.model';
import {ContactDataModel} from './contact-data.model';

export class RegistrationData {
  offerId: string;
  premiumId: string;
  cession: CessionData;
  paymentMethod: string;
  owner: OwnerRegistrationData;
  vehicle: VehicleRegistrationData;
  insurer: InsurerRegistrationData;
  agreements: Array<AgreementModel>;
  contact: ContactDataModel;
  modificationCoverages: any[];
  currentAmount: number;
}
